import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import heroImage from "../../heroImage.jpg";

const HeroSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { when: "beforeChildren", staggerChildren: 0.3, duration: 1 },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const imageVariants = {
    hidden: { scale: 1.2, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 0.6,
      transition: { duration: 1.2, ease: "easeOut" },
    },
  };

  const scrollToGallery = () => {
    const gallerySection = document.getElementById("gallery");
    if (gallerySection) gallerySection.scrollIntoView({ behavior: "smooth" });
  };

  // responsive background size: reduce zoom on small screens
  const [bgSize, setBgSize] = useState("auto 150%");

  useEffect(() => {
    const updateBg = () => {
      const w = typeof window !== "undefined" ? window.innerWidth : 1024;
      if (w < 640) {
        setBgSize("auto 100%");
      } else if (w < 1024) {
        setBgSize("auto 130%");
      } else {
        setBgSize("auto 150%");
      }
    };

    updateBg();
    window.addEventListener("resize", updateBg);
    return () => window.removeEventListener("resize", updateBg);
  }, []);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Image using a div */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={imageVariants}
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: bgSize,
          backgroundPosition: "center",
        }}
      ></motion.div>

      {/* Content */}
      <div className="relative z-10 h-full container mx-auto px-4 flex flex-col justify-between items-center text-center py-24">
        {/* Top Content: Title and Paragraph */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="w-full max-w-3xl"
        >
          <motion.h1
            variants={itemVariants}
            className="text-3xl md:text-3xl font-bold mb-4 text-accent-light leading-tight drop-shadow-lg"
          >
            {" "}
            en la posibilidad habita todo, por eso escribo, pinto, invento
          </motion.h1>
          <motion.p
            variants={itemVariants}
            className="text-xl md:text-2xl mb-10 text-accent-light text-opacity-90 max-w-2xl mx-auto drop-shadow-md"
          >
            {" "}
          </motion.p>
        </motion.div>

        {/* Bottom Content: Button */}
        {/*<motion.div
          initial="hidden"
          animate="visible"
          variants={itemVariants}
          transition={{ delay: 0.6 }}
        >
          <motion.button
            onClick={scrollToGallery}
            className="bg-white hover:bg-accent-light text-primary-dark py-3 px-8 rounded-full text-lg font-semibold shadow-lg flex items-center gap-2 mx-auto transition duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Explorar Galería
            <ArrowDown className="w-5 h-5" />
          </motion.button>
        </motion.div>*/}
      </div>
    </section>
  );
};

export default HeroSection;
